import * as React from 'react';

// Utils
import cx from 'classnames';

// Styles
import styles from './style.scss';

type Props = {
  icon?: React.ReactNode;
  className?: string;
  title?: string;
  style?: React.CSSProperties;
  children: React.ReactNode;
  type?: 'success' | 'caution' | 'general' | 'error';
};

function Tip({
  icon,
  className = '',
  title,
  style,
  children,
  type = 'general',
}: Props): JSX.Element {
  return (
    <div
      className={cx(styles.container, styles[`${type}Container`], className)}
      style={style}
    >
      <div
        className={cx(
          styles.iconContainer,
          !!title && styles.iconContainerWithTitle
        )}
      >
        {icon}
      </div>
      <div>
        {title && (
          <div className={cx(styles.title, styles[`${type}Title`])}>
            {title}
          </div>
        )}
        {children}
      </div>
    </div>
  );
}

export default Tip;
